// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Debugger$Showside from "../utils/Debugger.bs.js";
import * as PullDown$Showside from "../utils/PullDown.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as IconClose$Showside from "../icons/IconClose.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as ScrollLock$Showside from "../utils/ScrollLock.bs.js";
import * as IframeEmbed$Showside from "../utils/IframeEmbed.bs.js";
import * as Slider_Lazy$Showside from "../utils/Slider_Lazy.bs.js";
import * as ReactZoomPanPinch from "react-zoom-pan-pinch";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as GalleryButton$Showside from "./GalleryButton.bs.js";
import * as QuickViewTabs$Showside from "./QuickViewTabs.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as SmartNavVideo$Showside from "./SmartNavVideo.bs.js";
import * as ExpandSequence$Showside from "../utils/ExpandSequence.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ResizeObserver2$Showside from "../utils/ResizeObserver2.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as DesktopPhotoZoom$Showside from "./DesktopPhotoZoom.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as RectToRectTransition$Showside from "../utils/RectToRectTransition.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function MobilePhotoSlider$MiniSlider$Slide(Props) {
  var rect = Props.rect;
  var item = Props.item;
  var index = Props.index;
  var visible = Props.visible;
  var durationCn = Props.durationCn;
  var phaseDuration = Props.phaseDuration;
  var fitToContainer = Props.fitToContainer;
  var containerWidth = Props.containerWidth;
  var containerHeight = Props.containerHeight;
  var getMediaSize = Props.getMediaSize;
  var onClick = Props.onClick;
  var onMainImageRendered = Props.onMainImageRendered;
  var settings = Props.settings;
  var match = React.useState(function () {
    return Curry._2(getMediaSize, containerHeight, item);
  });
  var size = match[0];
  var mediaHeight = size[1];
  var mediaWidth = size[0];
  var setSize = match[1];
  var mediaWidth$1 = fitToContainer ? Math.min(mediaWidth, containerWidth) : mediaWidth;
  var match$1 = React.useState(function () {
    return false;
  });
  var setGrabbingImage = match$1[1];
  var cursor = match$1[0] ? "cursor-grab" : "cursor-zoom-in";
  var largeContainer = {
    x: 0,
    y: 0,
    width: mediaWidth$1,
    height: mediaHeight
  };
  var naturalSize = {
    width: mediaWidth$1,
    height: mediaHeight
  };
  var onLoad = function (param) {
    var completeFit = SmartImg$Showside.calcObjectFit(param.width, param.height, undefined, containerHeight, /* Contain */2);
    Curry._1(setSize, function (param) {
      return [completeFit.width, completeFit.height];
    });
  };
  var tmp = {
    largeContainer: largeContainer,
    naturalSize: naturalSize,
    smallFitRule: "cover",
    largeFitRule: "contain",
    duration: phaseDuration,
    render: function (param) {
      switch (item.TAG | 0) {
        case /* Image */0:
          return React.createElement(SmartImg$Showside.Sized.make, {
            src: item._0.url,
            containerWidth: mediaWidth$1,
            containerHeight: mediaHeight,
            fit: /* Contain */2,
            priority: 0,
            onLoad: onLoad,
            onRender: function (param) {
              if (index === 0) {
                return Curry._1(onMainImageRendered, undefined);
              }
            },
            noFlicker: true
          });
        case /* Video */1:
          var video = item._0;
          var src = Belt_Option.map(Product$Showside.getVideoSource(video), function (source) {
            return source.url;
          });
          if (src === undefined) {
            return null;
          }
          var tmp = {
            src: src,
            prioritize: true,
            autoplay: settings.videoAutoPlay,
            loop: settings.videoLoop,
            muted: settings.videoMute,
            controls: settings.videoControls,
            key: src
          };
          if (video.posterUrl !== undefined) {
            tmp.poster = video.posterUrl;
          }
          return React.createElement(SmartNavVideo$Showside.make, tmp);
        case /* IframeEmbed */2:
          return React.createElement(IframeEmbed$Showside.make, {
            url: item._0.url
          });
      }
    }
  };
  if (rect !== undefined) {
    tmp.smallContainer = Caml_option.valFromOption(rect);
  }
  return React.createElement(ScrollLock$Showside.make, {
    children: React.createElement(DataAttribute$Showside.make, {
      dataTestId: "pdp-photo",
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["select-none relative transition-opacity", cursor, visible ? "opacity-100" : "opacity-0", "product-photo-" + String(index), durationCn])),
        style: {
          height: CSS$Showside.intToPx(mediaHeight),
          width: CSS$Showside.intToPx(mediaWidth$1)
        },
        onClick: function (param) {
          Curry._1(onClick, undefined);
        },
        onMouseDown: function (param) {
          Curry._1(setGrabbingImage, function (param) {
            return true;
          });
        },
        onMouseUp: function (param) {
          Curry._1(setGrabbingImage, function (param) {
            return false;
          });
        }
      }, React.createElement(Debugger$Showside.make, {
        logs: [{
          TAG: /* Log */0,
          _0: "containerWidth: " + String(containerWidth)
        }, {
          TAG: /* Log */0,
          _0: "containerHeight: " + String(containerHeight)
        }, {
          TAG: /* Log */0,
          _0: ">> mediaWidth: " + String(mediaWidth$1)
        }, {
          TAG: /* Log */0,
          _0: "mediaHeight: " + String(mediaHeight)
        }],
        enabled: false,
        children: React.createElement(RectToRectTransition$Showside.make, tmp)
      }))
    })
  });
}
MobilePhotoSlider$MiniSlider$Slide.displayName = "MobilePhotoSlider.MiniSlider.Slide";
var Slide = {
  make: MobilePhotoSlider$MiniSlider$Slide
};
function MobilePhotoSlider$MiniSlider(Props) {
  var product = Props.product;
  var variantId = Props.variantId;
  var productId = Props.productId;
  var phase = Props.phase;
  var phaseDuration = Props.phaseDuration;
  var productCategory = Props.productCategory;
  var windowWidth = Props.windowWidth;
  var windowHeight = Props.windowHeight;
  var fitToContainer = Props.fitToContainer;
  var containerWidth = Props.containerWidth;
  var containerRef = Props.containerRef;
  var zoomedIndex = Props.zoomedIndex;
  var medias = Props.medias;
  var getMediaSize = Props.getMediaSize;
  var onClick = Props.onClick;
  var onMainImageRendered = Props.onMainImageRendered;
  var onSlideChange = Props.onSlideChange;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var cardShape = Category$Showside.CategoryCard.getCardShape(settings.productCardShape, [/* Square */1, /* Portrait */3, /* Landscape */2], productCategory.card);
  var minHeight = cardShape === 1 ? windowWidth : 450;
  var containerHeight = Caml.int_min(minHeight, windowHeight * 0.65 | 0);
  var durationCn = CSS$Showside.duration(phaseDuration);
  var minimal = phase !== /* CompleteFullscreen */2;
  var slides = Belt_Array.mapWithIndex(medias, function (i, item) {
    var rect = i === 0 && typeof phase !== "number" ? phase._0 : undefined;
    return React.createElement(MobilePhotoSlider$MiniSlider$Slide, {
      rect: rect,
      item: item,
      index: i,
      visible: i === 0 || !minimal,
      durationCn: durationCn,
      phaseDuration: phaseDuration,
      fitToContainer: fitToContainer,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      getMediaSize: getMediaSize,
      onClick: function (param) {
        Curry._1(onClick, i);
      },
      onMainImageRendered: onMainImageRendered,
      settings: settings
    });
  });
  var stopTouchPropagation = function (prim) {
    prim.stopPropagation();
  };
  var tmp = {
    items: slides,
    spaceBetween: 2,
    enableFreeMode: true,
    freeModeSticky: true,
    freeModeMomentumVelocityRatio: 0.2,
    centeredSlides: true,
    centeredSlidesBounds: true,
    autoHeight: false,
    enableScrollbar: slides.length > 1,
    enableMousewheel: true,
    className: Cn.make([CSS$Showside.prefix("h-full w-full"), "swiper-overflow-visible", minimal ? "swiper-hide-scrollbar" : ""]),
    onSlideChange: function (param) {
      Curry._1(onSlideChange, undefined);
    },
    key: "mobile-photo-slider-" + productId + ""
  };
  if (zoomedIndex !== undefined) {
    tmp.slideToIndex = Caml_option.valFromOption(zoomedIndex);
  }
  var tmp$1 = minimal ? undefined : "pdp-photo-slider";
  if (tmp$1 !== undefined) {
    tmp.restorationId = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(containerRef),
    className: CSS$Showside.prefix("relative flex-shrink-0"),
    style: {
      backgroundColor: settings.pdpGalleryBGColor,
      height: CSS$Showside.intToPx(containerHeight)
    },
    onTouchEnd: stopTouchPropagation,
    onTouchMove: stopTouchPropagation,
    onTouchStart: stopTouchPropagation
  }, React.createElement(Slider_Lazy$Showside.make, tmp), React.createElement("div", {
    className: CSS$Showside.prefix("absolute bottom-4 right-4")
  }, React.createElement(GalleryButton$Showside.make, {
    product: product,
    variantId: variantId
  })));
}
MobilePhotoSlider$MiniSlider.displayName = "MobilePhotoSlider.MiniSlider";
var MiniSlider = {
  Slide: Slide,
  make: MobilePhotoSlider$MiniSlider
};
function getMediaSize(height, windowWidth, windowHeight, item) {
  var link;
  switch (item.TAG | 0) {
    case /* Image */0:
      link = item._0.url;
      break;
    case /* Video */1:
      link = item._0.posterUrl;
      break;
    case /* IframeEmbed */2:
      link = undefined;
      break;
  }
  var cached = Belt_Option.flatMap(link, SmartImg$Showside.getCached);
  var mediaSize;
  switch (item.TAG | 0) {
    case /* Image */0:
      var match = item._0;
      var height$1 = match.height;
      var width = match.width;
      mediaSize = width > 0 && height$1 > 0 ? {
        src: Belt_Option.getWithDefault(link, ""),
        naturalWidth: width,
        naturalHeight: height$1,
        color: undefined
      } : undefined;
      break;
    case /* Video */1:
      var match$1 = Product$Showside.Media.getVideoSource(item._0);
      if (match$1 !== undefined) {
        var height$2 = match$1.height;
        var width$1 = match$1.width;
        mediaSize = width$1 > 0 && height$2 > 0 ? {
          src: Belt_Option.getWithDefault(link, ""),
          naturalWidth: width$1,
          naturalHeight: height$2,
          color: undefined
        } : undefined;
      } else {
        mediaSize = undefined;
      }
      break;
    case /* IframeEmbed */2:
      mediaSize = undefined;
      break;
  }
  var cached$1 = mediaSize !== undefined ? mediaSize : cached !== undefined ? cached : undefined;
  var match$2;
  if (cached$1 !== undefined) {
    var completeFit = SmartImg$Showside.calcObjectFit(cached$1.naturalWidth, cached$1.naturalHeight, undefined, height, /* Contain */2);
    match$2 = [completeFit.width, completeFit.height];
  } else {
    match$2 = [windowWidth, Belt_Option.getWithDefault(height, windowHeight)];
  }
  return [match$2[0], match$2[1]];
}
function MobilePhotoSlider(Props) {
  var product = Props.product;
  var productId = Props.productId;
  var variantId = Props.variantId;
  var medias = Props.medias;
  var phaseOpt = Props.phase;
  var phaseDurationOpt = Props.phaseDuration;
  var fitToContainerOpt = Props.fitToContainer;
  var onPhotoZoomed = Props.onPhotoZoomed;
  var onClickImage = Props.onClickImage;
  var onSlideChange = Props.onSlideChange;
  var onClickThumbnail = Props.onClickThumbnail;
  var viewport = Props.viewport;
  var settings = Props.settings;
  var productCategory = Props.productCategory;
  var phase = phaseOpt !== undefined ? phaseOpt : /* CompleteFullscreen */2;
  var phaseDuration = phaseDurationOpt !== undefined ? phaseDurationOpt : 0;
  var fitToContainer = fitToContainerOpt !== undefined ? fitToContainerOpt : true;
  var match = RouterProvider$Showside.useRouter(undefined);
  var route = match.route;
  var match$1 = LCPContext$Showside.use(undefined);
  var match$2 = ViewportContext$Showside.use(undefined);
  var match$3 = match$2.windowSize;
  var windowHeight = match$3.height;
  var windowWidth = match$3.width;
  var isMobile = match$2.isMobile;
  var match$4 = EntrypointContext$Showside.use(undefined);
  var trackEvent = match$4.trackEvent;
  var match$5 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var clearSlideChangeTimeout = match$5.clearTimeout;
  var setSlideChangeTimeout = match$5.setTimeout;
  var zoomedIndex;
  if (typeof route === "number") {
    zoomedIndex = undefined;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        zoomedIndex = route._0.zoomedPhotoIndex;
        break;
      case /* QuickView */3:
        zoomedIndex = route._0.zoomedPhotoIndex;
        break;
      default:
        zoomedIndex = undefined;
    }
  }
  var containerRef = React.useRef(null);
  var match$6 = Belt_Option.mapWithDefault(ResizeObserver2$Showside.useResizeObserver(containerRef), [windowWidth, windowHeight], function (size) {
    return [size.width, size.height];
  });
  var goToSlide = function (index) {
    Curry._1(clearSlideChangeTimeout, undefined);
    setSlideChangeTimeout(function (param) {
      Curry._1(onPhotoZoomed, index);
    }, 30);
  };
  var enterZoom = React.useCallback(function (index) {
    goToSlide(index);
    Curry.app(trackEvent, ["Clicked PDP Photo", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  }, [goToSlide, trackEvent]);
  var exitZoom = function (param) {
    Curry._1(onPhotoZoomed, undefined);
  };
  var images = Belt_Array.keepMap(medias, function (item) {
    switch (item.TAG | 0) {
      case /* Image */0:
        return item._0.url;
      case /* Video */1:
        return item._0.posterUrl;
      case /* IframeEmbed */2:
        return;
    }
  });
  var total = images.length;
  var match$7 = React.useState(function () {
    return false;
  });
  var setZoomed = match$7[1];
  var zoomed = match$7[0];
  var handleZoom = function (ref, $$event) {
    Curry._1(setZoomed, function (param) {
      return ref.state.scale > 1;
    });
  };
  var isOpen = Belt_Option.isSome(zoomedIndex);
  var onClick = function (index) {
    Curry._1(onClickImage, undefined);
    Curry._1(enterZoom, index);
  };
  return React.createElement(React.Fragment, undefined, React.createElement(MobilePhotoSlider$MiniSlider, {
    product: product,
    variantId: variantId,
    productId: productId,
    phase: phase,
    phaseDuration: phaseDuration,
    productCategory: productCategory,
    windowWidth: windowWidth,
    windowHeight: windowHeight,
    fitToContainer: fitToContainer,
    containerWidth: match$6[0],
    containerRef: containerRef,
    zoomedIndex: zoomedIndex,
    medias: medias,
    getMediaSize: function (param) {
      return function (param$1) {
        return getMediaSize(param, windowWidth, windowHeight, param$1);
      };
    },
    onClick: onClick,
    onMainImageRendered: match$1.onMainImageRendered,
    onSlideChange: onSlideChange
  }), React.createElement(BaseWithTheme$Showside.make, {
    initiator: "mobile-photo-slider",
    portal: true,
    children: React.createElement(ExpandSequence$Showside.make, {
      isOpen: isOpen,
      getSourceEl: function (param) {
        return Belt_Option.flatMap(Belt_Option.map(zoomedIndex, function (index) {
          return ".QVTW__product-photo-" + String(index);
        }), function (qs) {
          var doc = document;
          return Caml_option.nullable_to_opt(doc.querySelector(qs));
        });
      },
      renderForeground: function (phase, duration) {
        if (zoomedIndex !== undefined) {
          if (isMobile) {
            var renderSlide = function (duration, item, index, rect) {
              var active = index === zoomedIndex;
              var match = getMediaSize(undefined, windowWidth, windowHeight, item);
              var mediaHeight = match[1];
              var mediaWidth = match[0];
              var naturalSize = rect !== undefined ? {
                width: rect.width,
                height: rect.height
              } : mediaWidth !== 0 && mediaHeight !== 0 ? {
                width: mediaWidth,
                height: mediaHeight
              } : undefined;
              if (naturalSize === undefined) {
                return null;
              }
              var largeContainer = {
                x: 0,
                y: 0,
                width: windowWidth,
                height: windowHeight
              };
              var tmp = {
                largeContainer: largeContainer,
                naturalSize: naturalSize,
                smallFitRule: "contain",
                largeFitRule: "contain",
                duration: duration,
                render: function (param) {
                  switch (item.TAG | 0) {
                    case /* Image */0:
                      return React.createElement("span", {
                        className: CSS$Showside.prefix("bg-white")
                      }, React.createElement(SmartImg$Showside.Sized.make, {
                        src: item._0.url,
                        containerWidth: windowWidth,
                        containerHeight: windowHeight,
                        fit: /* Contain */2,
                        priority: active ? 0 : 1
                      }));
                    case /* Video */1:
                      var video = item._0;
                      var src = Belt_Option.map(Product$Showside.getVideoSource(video), function (source) {
                        return source.url;
                      });
                      if (src === undefined) {
                        return null;
                      }
                      var tmp = {
                        src: src,
                        prioritize: true,
                        autoplay: settings.videoAutoPlay,
                        loop: settings.videoLoop,
                        muted: settings.videoMute,
                        controls: settings.videoControls,
                        key: variantId
                      };
                      if (video.posterUrl !== undefined) {
                        tmp.poster = video.posterUrl;
                      }
                      return React.createElement(SmartNavVideo$Showside.make, tmp);
                    case /* IframeEmbed */2:
                      return React.createElement(IframeEmbed$Showside.make, {
                        url: item._0.url
                      });
                  }
                }
              };
              if (rect !== undefined) {
                tmp.smallContainer = Caml_option.valFromOption(rect);
              }
              return React.createElement(PullDown$Showside.make, {
                onPullDown: exitZoom,
                children: React.createElement(ReactZoomPanPinch.TransformWrapper, {
                  panning: {
                    disabled: !zoomed
                  },
                  doubleClick: {
                    disabled: true
                  },
                  onZoom: handleZoom,
                  children: React.createElement(ReactZoomPanPinch.TransformComponent, {
                    wrapperClass: CSS$Showside.prefix("absolute inset-0 w-full h-full"),
                    contentClass: CSS$Showside.prefix("absolute inset-0 w-full h-full"),
                    children: React.createElement(React.Fragment, undefined, React.createElement("div", {
                      className: CSS$Showside.prefix("absolute inset-0 no-flicker"),
                      onClick: function (param) {
                        Curry._1(onPhotoZoomed, undefined);
                      }
                    }), React.createElement(RectToRectTransition$Showside.make, tmp))
                  })
                })
              });
            };
            var closeButton = React.createElement(QuickViewButton$Showside.make, {
              color: /* Light */1,
              className: CSS$Showside.prefix("inline-block rounded-full p-4"),
              onClick: function (param) {
                Curry._1(onPhotoZoomed, undefined);
                Curry.app(trackEvent, ["Clicked PDP Carousel Close Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
              },
              children: React.createElement(IconClose$Showside.make, {
                className: CSS$Showside.prefix("w-5 h-5")
              }),
              dataTestId: "photo-zoom-close-button"
            });
            var renderBlur = function (phase) {
              var show = phase !== 0;
              return React.createElement("div", {
                className: CSS$Showside.prefix(Cn.make(["absolute inset-0 backdrop-blur transition-opacity no-flicker", show ? "duration-0 opacity-100" : "duration-0 opacity-0"]))
              });
            };
            var renderSlider = function (phase, duration) {
              var minimal = phase !== /* CompleteFullscreen */2;
              var slides = Belt_Array.mapWithIndex(medias, function (i, item) {
                if (!(!minimal || i === zoomedIndex)) {
                  return renderSlide(duration, item, i, undefined);
                }
                var rect = typeof phase === "number" ? undefined : phase._0;
                return renderSlide(duration, item, i, rect);
              });
              return React.createElement("div", {
                className: CSS$Showside.prefix("absolute inset-0 no-flicker")
              }, React.createElement(Slider_Lazy$Showside.make, {
                items: slides,
                initialSlide: zoomedIndex,
                slidesPerView: /* Float */{
                  _0: 1
                },
                autoHeight: false,
                slideToIndex: zoomedIndex,
                enableKeyboard: true,
                enableNavigation: !isMobile,
                className: CSS$Showside.prefix("absolute inset-0 no-flicker"),
                onSlideChange: function (e) {
                  goToSlide(e.activeIndex);
                },
                keepDisabledButtonsVisible: true
              }), React.createElement(QuickViewTabs$Showside.make, {
                index: zoomedIndex,
                total: total,
                onClick: function (i) {
                  goToSlide(i);
                },
                isMobile: isMobile,
                dataTestId: "photo-zoom-tabs"
              }));
            };
            return React.createElement(React.Fragment, undefined, renderBlur(phase), renderSlider(phase, duration), React.createElement("div", {
              className: CSS$Showside.prefix("p-5 absolute top-0 right-0")
            }, closeButton));
          } else {
            return React.createElement(DesktopPhotoZoom$Showside.make, {
              product: product,
              variantId: variantId,
              medias: medias,
              viewport: viewport,
              onSlideChange: function (param) {
                Curry._1(onSlideChange, undefined);
              },
              onClickThumbnail: onClickThumbnail,
              bgBlur: false,
              thumbnailsPosition: "center",
              selectedIndex: zoomedIndex,
              onClose: function (param) {
                Curry._1(onPhotoZoomed, undefined);
              },
              onPhotoZoomed: onPhotoZoomed
            });
          }
        } else {
          return null;
        }
      }
    })
  }));
}
MobilePhotoSlider.displayName = "MobilePhotoSlider";
var make = MobilePhotoSlider;
export { MiniSlider, getMediaSize, make };
/* react Not a pure module */